import moment from 'moment'

const mapOptions = (array) => {
  return array.map((x) => {return {key: x, text: x, value: x} })
}

const upfrontOptions = mapOptions(
  [
    'Show All',
    'NO, From Stock',
    'YES, Upfront',
    'Missing',
  ]
)

const ticketedOptions = mapOptions(
  [
    'Show All',
    'NO',
    'Ordered',
    'Not Ordered',
  ]
)

const shippingClassOptions = mapOptions(
  [
    'Show All',
    'POE',
    'FOB China',
    'FOB NY',
    'No',
  ]
)

const marginsOptions = mapOptions(
  [
    'Show All',
    'A 55%+',
    'B 45%-54%',
    'C 36%-44%',
    'D 25%-35%',
    'E -24%',
    'Missing'
  ]
)

//12 months ahead back to January 2022, newest first
const getMonths = () => {
  let months = []
  let month = moment().add(12, 'months').startOf('month')
  while (month.isSameOrAfter('2022-01-01')) {
    months.push(month.format('MMMM YYYY'))
    month.subtract(1, 'month')
  }
  return months
}

const monthsOptions = mapOptions(['Show All', ...getMonths()])

export {upfrontOptions, ticketedOptions, shippingClassOptions, marginsOptions, monthsOptions}
